var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "svincolati" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTitle,
                expression: "showTitle",
              },
            ],
            staticClass: "titolo navy--text text--lighten-2 font-hemi-head",
          },
          [_vm._v("\n      Svincolati\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "svincolati-options" }, [
          _c(
            "div",
            [
              _vm.classic
                ? _c(
                    "v-row",
                    {
                      attrs: {
                        align: "center",
                        justify: "center",
                        "no-gutters": "",
                      },
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("select-ruoli-classic", {
                            attrs: { ruoliAllowed: _vm.ruoliAllowed },
                            model: {
                              value: _vm.selectedRuoloClassic,
                              callback: function ($$v) {
                                _vm.selectedRuoloClassic = $$v
                              },
                              expression: "selectedRuoloClassic",
                            },
                          }),
                          _vm._v(" "),
                          _vm.showInformazioni
                            ? _c(
                                "v-icon",
                                {
                                  attrs: { color: "text", small: "" },
                                  on: { click: _vm.showDialogInformazioni },
                                },
                                [_vm._v("info")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-row",
                    {
                      attrs: {
                        align: "center",
                        justify: "center",
                        "no-gutters": "",
                      },
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("select-ruoli-mantra", {
                            model: {
                              value: _vm.selectedRuoliMantra,
                              callback: function ($$v) {
                                _vm.selectedRuoliMantra = $$v
                              },
                              expression: "selectedRuoliMantra",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.showButtonScartati
                ? _c(
                    "v-row",
                    {
                      attrs: {
                        align: "center",
                        justify: "center",
                        "no-gutters": "",
                      },
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2 navy--text text--darken-3",
                              attrs: {
                                "x-small": "",
                                outlined: "",
                                rounded: "",
                              },
                              on: { click: _vm.manageScartati },
                            },
                            [_vm._v("Scartati")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-row",
                {
                  attrs: {
                    align: "center",
                    justify: "space-between",
                    dense: "",
                  },
                },
                [
                  _vm.showStats
                    ? _c(
                        "v-col",
                        [
                          _vm.anniStats.length > 0
                            ? _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "navy darken-2 navy--text text--lighten-3",
                                  attrs: {
                                    "x-small": "",
                                    rounded: "",
                                    depressed: "",
                                  },
                                  on: { click: _vm.rotateAnniStats },
                                },
                                [
                                  _c(
                                    "transition",
                                    { attrs: { name: "roll", mode: "out-in" } },
                                    [
                                      _c("b", { key: _vm.annoStats }, [
                                        _vm._v(_vm._s(_vm.annoStats)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "btnHomeAway navy darken-2 navy--text text--lighten-3",
                              attrs: {
                                "x-small": "",
                                rounded: "",
                                depressed: "",
                              },
                              on: { click: _vm.rotateHomeAway },
                            },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "roll", mode: "out-in" } },
                                [
                                  _c("div", { key: _vm.homeAway }, [
                                    _vm.homeAway == "home"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("fa-home")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.homeAway == "away"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("fa-plane")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.homeAway == "homeAway"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("fa-home")]
                                            ),
                                            _vm._v(
                                              "\n                    +\n                    "
                                            ),
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("fa-plane")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        staticClass: "calciatori-search",
                        attrs: {
                          "prepend-icon": "search",
                          label: "Nome o squadra...",
                          color: "blue-grey lighten-2",
                          "append-icon":
                            _vm.nameFilter.length != 0 ? "cancel" : "",
                          "hide-details": "",
                        },
                        on: { "click:append": _vm.resetFilter },
                        model: {
                          value: _vm.nameFilter,
                          callback: function ($$v) {
                            _vm.nameFilter = $$v
                          },
                          expression: "nameFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "svincolati-list" }, [
          _vm.id_calciatori_svincolati.length == 0
            ? _c("div", { staticClass: "text-center pa-10" }, [
                _vm._v("\n        Nessuno svincolato in questo ruolo."),
                _c("br"),
                _vm._v(" "),
                _vm.showButtonScartati && !_vm.includiScartati
                  ? _c("div", [
                      _vm._v(
                        '\n          PS: Clicca su "Scartati" per rivedere i calciatori che sono stati\n          già scartati\n        '
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm.ie
            ? _c(
                "div",
                { staticStyle: { overflow: "auto" } },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0", attrs: { "two-line": "" } },
                    _vm._l(_vm.id_calciatori_svincolati, function (id) {
                      return _c("calciatore", {
                        key: id,
                        class: {
                          textScuro: _vm.textScuro,
                          bgChiaro: _vm.bgChiaro,
                        },
                        attrs: {
                          borderAsRuolo: "",
                          showQuotazione: _vm.showQuotazione,
                          showMainStatus: _vm.showMainStatus,
                          showButtonsScartaRiabilita:
                            _vm.showButtonsScartaRiabilita,
                          showStats: _vm.showStats,
                          ruoloRight: "",
                          id: id,
                          selected: _vm.selected.bind(null, id),
                          scartato: _vm.scartati_ids.indexOf(id) != -1,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("RecycleScroller", {
                    ref: "vscroll-list",
                    staticClass: "recycle-scroller",
                    class: { "nice-scroll": !_vm.is_mobile },
                    attrs: {
                      items: _vm.id_calciatori_svincolati,
                      "item-size": _vm.showStats ? 91 : 65,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var id_calciatore_svincolato = ref.item
                          return [
                            _c("calciatore", {
                              class: {
                                textScuro: _vm.textScuro,
                                bgChiaro: _vm.bgChiaro,
                              },
                              attrs: {
                                borderAsRuolo: "",
                                showQuotazione: _vm.showQuotazione,
                                showMainStatus: _vm.showMainStatus,
                                showButtonsScartaRiabilita:
                                  _vm.showButtonsScartaRiabilita,
                                showStats: _vm.showStats,
                                ruoloRight: "",
                                ripple: _vm.ripple,
                                id: id_calciatore_svincolato,
                                selected: _vm.selected.bind(
                                  null,
                                  id_calciatore_svincolato
                                ),
                                scartato:
                                  _vm.scartati_ids.indexOf(
                                    id_calciatore_svincolato
                                  ) != -1,
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "350" },
          model: {
            value: _vm.dialogInformazioni,
            callback: function ($$v) {
              _vm.dialogInformazioni = $$v
            },
            expression: "dialogInformazioni",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "navy white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("info")]
                  ),
                  _vm._v("\n        Ricorda\n        "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismissDialogInformazioni },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "white" }, [
                _vm.ruolo_da_chiamare ==
                _vm.Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
                  ? _c("div", { staticClass: "pa-4" }, [
                      _vm._v(
                        "\n          PS: Se un ruolo non dovesse essere selezionabile è perchè quel ruolo\n          è stato già completato da chi sta chiamando.\n        "
                      ),
                    ])
                  : _c("div", { staticClass: "pa-4" }, [
                      _vm._v(
                        "\n          PS: Se il ruolo non dovesse essere selezionabile è perchè quel ruolo\n          è stato già completato da chi sta chiamando.\n        "
                      ),
                    ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }